import React, { Component } from 'react';
import _ from 'lodash';

import SessionStorageService from '../services/utilities/SessionStorageService';
import LwTalkroomTable from '../components/tables/LwTalkroomTable';
import {
  LwTalkroomRegisterModal,
  LwTalkroomShowModal,
} from '../components/lwUser/topModalTalkroom';
import LwTalkroomApi from '../services/LwTalkroomApi';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import { messageUtility } from '../utilities/messageUtility';
import { FieldService } from '../services/Fields';
import _slideLoader from '../utilities/slideLoader';
import urlParamManager from '../utilities/urlParamManager';
import Helmet from 'react-helmet';
import { HEADER_CONSTANTS } from '../utilities/constants';
import { ConferencePageHeader } from '../components/PageHeader';
import LwGroupApi from '../services/LwGroupApi';

const LwTalkroomLayout = ({ children, vw }) => {
  const handleCloseSlide = () => {
    _slideLoader.close(vw);
  };
  const slide = urlParamManager.getSlideParam();

  return (
    <div className='LineTalkrooms'>
      <div className='slide-view show'>
        {slide[0] === '0' && ( // リロード時他ページのtitleを上書きする問題の対策
          <Helmet>
            <title>
              {HEADER_CONSTANTS.conference} - LINE WORKS トークルーム一覧
            </title>
          </Helmet>
        )}
        <div className='slide-view__view'>
          <ConferencePageHeader
            onClose={handleCloseSlide}
            title='LINE WORKS トークルーム一覧'
          />
          {children}
        </div>
      </div>
    </div>
  );
};

export class LwTalkrooms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldTreeId: SessionStorageService.getFieldTreeId(),
      isDisplayCreateDialog: false,
      isDisplayShowDialog: false,
      lwTalkrooms: [],
      lwTalkroomId: null,
      lwTalkroomName: null,
      isLoading: true,
      updatedCss: false,
      field: {
        id: SessionStorageService.getFieldId(),
        name: '',
      },
    };
    this.isDeleteFlag = false;
  }

  async componentDidMount() {
    /*リロード時にlwGroupIdがpropsから取得できないため、確認し必要なら再取得する*/
    if (typeof this.props.view.state.lwGroupId === 'number') {
      this.lwGroupId = this.props.view.state.lwGroupId;
    } else {
      const lwGroupId = await this.getCurrentLwGroupId(this.state.field.id);
      if (lwGroupId !== null && lwGroupId !== '') {
        this.lwGroupId = lwGroupId;
      } else {
        const { vw } = this.props;
        _slideLoader.close(vw);
        return;
      }
    }
    this.setFieldNameById(this.state.field.id);
    this.loadLwTalkrooms();
    const message = document.querySelector('.global-header__message');
    const divFixed = document.querySelector('.fixed-scroller-header');
    if (message) {
      divFixed.style.height = 'calc(100vh - 122px)';
      this.setState({ updatedCss: true });
    } else {
      divFixed.addEventListener('scroll', () => {
        const message = document.querySelector('.global-header__message');
        if (message && !this.state.updatedCss) {
          divFixed.style.height = 'calc(100vh - 122px)';
          this.setState({ updatedCss: true });
        }
      });
    }
  }

  componentWillUnmount() {
    const divFixed = document.querySelector('.fixed-scroller-header');
    divFixed.removeEventListener('scroll', () => {});
  }

  getCurrentLwGroupId = async fieldId => {
    let lwGroupId = null;
    const { result, data } = await LwGroupApi.current_user_belonged_lw_group(
      fieldId
    );
    if (!result || data.total <= 0) {
      return lwGroupId;
    }
    lwGroupId = _.get(data, 'entities.lw_group.id', '');
    if (typeof lwGroupId !== 'number') {
      lwGroupId = null;
    }
    return lwGroupId;
  };

  setFieldNameById(fieldId) {
    if (fieldId) {
      FieldService.info(fieldId).then(response => {
        if (response.result) {
          this.setState({
            field: {
              id: fieldId,
              name: response.data.entities.field.name,
            },
          });
        }
      });
    }
  }

  lwRefreshList = () => {
    this.setState(
      {
        isLoading: true,
      },
      this.loadLwTalkrooms
    );
  };

  showModalCreate = () => {
    this.setState({ isDisplayCreateDialog: true });
  };

  showModalShow = (lwTalkroomId, lwTalkroomName) => {
    this.setState({
      isDisplayShowDialog: true,
      lwTalkroomId,
      lwTalkroomName,
    });
  };

  loadLwTalkrooms = async () => {
    const { result, data } = await LwTalkroomApi.list(this.state.field.id);
    if (result && data.total > 0) {
      this.setState({
        lwTalkrooms: _.get(data, 'entities.lw_talkrooms', []),
        isLoading: false,
      });
    } else {
      this.setState({
        lwTalkrooms: [],
        isLoading: false,
      });
    }
  };

  render() {
    const { vw } = this.props;
    return (
      <LwTalkroomLayout vw={vw}>
        <div className='master-slide-view__table fixed-scroller-header'>
          <header>
            <button className='btn' onClick={this.showModalCreate}>
              新規作成
            </button>
          </header>
          <main>
            <div>
              <LwTalkroomTable
                lwTalkrooms={this.state.lwTalkrooms}
                onShow={(lwTalkroomId, lwTalkroomName) =>
                  this.showModalShow(lwTalkroomId, lwTalkroomName)
                }
              />
              <InfinityScrollLoad
                isLoading={this.state.isLoading}
                total={_.size(this.state.lwTalkrooms)}
                no_data_message={messageUtility.getMessage('I-000-005')}
              />
            </div>
          </main>
          {this.state.isDisplayCreateDialog && (
            <LwTalkroomRegisterModal
              fieldId={this.state.field.id}
              fieldName={this.state.field.name}
              lwGroupId={this.lwGroupId}
              clickBack={() => {
                this.lwRefreshList();
                this.setState({ isDisplayCreateDialog: false });
              }}
              clickSubmit={() => {
                this.lwRefreshList();
                this.setState({ isDisplayCreateDialog: false });
              }}
            />
          )}
          {this.state.isDisplayShowDialog && (
            <LwTalkroomShowModal
              fieldId={this.state.field.id}
              fieldName={this.state.field.name}
              lwTalkroomId={this.state.lwTalkroomId}
              lwTalkroomName={this.state.lwTalkroomName}
              clickBack={() => {
                this.lwRefreshList();
                this.setState({ isDisplayShowDialog: false });
              }}
            />
          )}
        </div>
      </LwTalkroomLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LwTalkrooms.jsx